<template>
  <div>
    <el-button class="uploading-btn btn primary" type="primary" popper-class="popper-uploading"
      @click="dialogVisible = true">导入</el-button>
    <el-dialog :visible.sync="dialogVisible" title="导入" width="30%" @close="handleCancel">
      <el-upload ref="upload" class="upload-demo" v-loading="uploading" :auto-upload="false" :file-list="fileList"
        :action="actionUrl + importUrl" :headers="uploadHeaders" :limit="1" drag :on-preview="handlePreview"
        :on-remove="handleRemove" :before-remove="beforeRemove" :on-exceed="handleExceed" :on-success="onSuccess"
        :on-error="onError" :on-change="handleChange">
        <div>
          <img src="@/assets/file-download-line.svg" alt="">
          <div class="el-upload__text" style="color: #000;">将文件拖到此处，或<em
              style="color: #1890FF;cursor: pointer;">点击上传</em></div>
        </div>
          <div style="font-size: 12px;" slot="tip" class="el-upload__tip">只能上传excel文件，并且只能上传200条数据</div>
        <div class="el-upload__tip" slot="tip">下载模板：<span style="color: #1890FF;cursor: pointer;"
            @click="handleCommand('download')">点击下载</span></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button :disabled="uploading" type="primary" @click="handleUpload">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/cookie";
import { GetExcelFile, ImportPeriodStock } from "@/api";
export default {
  props: {
    fileName: {
      type: String,
      default: "药品基础信息维护导入模板.xlsx",
    },
    importUrl: {
      type: String,
      default: "/Import/ImportPeriodStock",
    },
  },
  data() {
    return {
      fileList: [],
      uploadHeaders: {
        Authorization: `Bearer ${getToken()}`,
        // 移除responseType，因为它不是HTTP头部
      },
      actionUrl: config.ExportServerHost,
      errTableData: [],
      dialogVisible: false,
      errTableDataNum: 0,
      hint: "",
      onSuccessData: null,
      uploading: false
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    // 添加手动上传方法
    handleUpload() {
      if (this.fileList.length == 0) {
        this.$my_message('请上传文件', 'warning');
        return;
      }
      this.uploading = true
      this.$refs.upload.submit();
    },
    handleRemove(file, uploadFiles) {
      console.log(file, uploadFiles);
    },
    handlePreview(uploadFile) {
    },
    // 新增上传失败处理方法
    onError(error, file, fileList) {
      this.uploading = false
      this.fileList = []
      console.error('文件上传失败:', error);
      // 显示错误提示
      this.$my_message('文件上传失败，请检查网络连接或联系管理员', 'error');

    },
    handleExceed(files, uploadFiles) {

    },
    beforeRemove(uploadFile, uploadFiles) {

    },
      handleChange(file, fileList) {
        
        this.fileList = fileList;
      },
    downloadBlob(blob, filename) {
      try {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("下载文件时发生错误:", error);
      }
    },
    onSuccess(response, file) {
      this.uploading = false
      if (response.returnData?.length > 0) {
         this.fileList = []
        let errMsg = response.errorMessage + '<br>'
        response.returnData.forEach(item => {
          errMsg += item + '<br>'
        })
        // 修改 $alert 弹窗的配置，添加 customClass 属性
        this.$alert(errMsg, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          customClass: 'scrollable-alert' // 添加自定义样式类
        });
        return
      }
      if (!response.successful){
         this.fileList = []
         this.$my_message(response.errorMessage, 'error');
         return
      }  
      this.dialogVisible = false
      this.$my_message("导入成功！", "success");
      this.$emit('getData')
      this.fileList = []
      this.dialogVisible = false

    },
    handleCancel(){
      this.fileList = []
      this.dialogVisible = false
    },
    handleCommand(type) {
      switch (type) {
        case "download":
          GetExcelFile({ code: '期初库存导入模版.xlsx' })
            .then(res => new Blob([res]))
            .then(data => {
              const blobUrl = window.URL.createObjectURL(data)
              const a = document.createElement('a')
              a.style.display = 'none'
               a.download = '期初库存导入模版.xlsx'
              a.href = blobUrl
              a.click()
            })
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
:deep(.el-upload-dragger) {
  background: #F5F7FE;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.error-table {
  padding-bottom: 20px;
}

.uploading-btn {
  margin-right: 0.7143rem;
}

:deep(.el-button--default) {
  margin-right: 0 !important;
}

:deep(.el-button:focus-visible) {
  outline: transparent;
}

.upload-demo {
  width: 100%;
}

:deep(.el-upload__tip) {
  font-size: 1rem;
}

:deep(.el-upload-dragger) {
  background: #F5F7FE;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* 添加自定义弹窗滚动样式 */
:deep(.scrollable-alert .el-message-box__content) {
  max-height: 300px;
  /* 设置最大高度，可根据需要调整 */
  overflow-y: auto;
  /* 内容超过高度时显示垂直滚动条 */
  white-space: pre-wrap;
  /* 保留空白和换行 */
}

/* 可以根据需要美化滚动条样式 */
:deep(.scrollable-alert .el-message-box__content::-webkit-scrollbar) {
  width: 6px;
}

:deep(.scrollable-alert .el-message-box__content::-webkit-scrollbar-track) {
  background: #f1f1f1;
  border-radius: 3px;
}

:deep(.scrollable-alert .el-message-box__content::-webkit-scrollbar-thumb) {
  background: #888;
  border-radius: 3px;
}

:deep(.scrollable-alert .el-message-box__content::-webkit-scrollbar-thumb:hover) {
  background: #555;
}

/* 其他现有样式 */
.error-table {
  padding-bottom: 20px;
}

.uploading-btn {
  margin-right: 0.7143rem;
}

:deep(.el-button--default) {
  margin-right: 0 !important;
}

:deep(.el-button:focus-visible) {
  outline: transparent;
}

.upload-demo {
  width: 100%;
}
</style>